import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import http from "axios";
import dayjs from "dayjs";

const marketer_age = (birthday) => {
    const bd = dayjs(birthday);

    const age = dayjs().diff(bd, 'year');

    return `${Math.floor(age/10)*10}代${age % 10 < 5 ? '前半' : '後半'}`;
};

const gender = (gen) => {
    if (gen == 1) return "男性";
    else if (gen == 2) return "女性";
    else return "不明";
}

const available_day = (day) => {
    if (day == 0) return "空き無し";
    if (day < 8) return `${day}日/週`;
    return "週末のみ";
};

const working_type = (type) => {
    if (type == 1) return "フリーランス";
    else if (type == 2) return "副業";
    else return "不明";
};

const role_type = (type) => {
    if (type == 1) return "サイトオーナー";
    else if (type == 2) return "ディレクター";
    else if (type == 3) return "ライター";
    else return "その他";
};

const status = (sts) => {
    if (sts == 1) return "登録済み";
    else if (sts == 8) return "停止";
    else return "不明";
};

export const isStop = (marketer) => {
    return marketer.status == 8;
};

const unit_value = (value, unit) => {
    if (value) return value.toLocaleString() + unit;
    return "未設定";
};

export function useMarketer(doget = true) {
    const marketer = ref({ works:[], genres:[], skills:[], pr: "", jobs:[], site: { keywords: [] } });
    const router = useRouter();
    const route = useRoute();

    const getMarketer = () => {
        http.get('/api/marketer/me').then(r => {
            marketer.value = r.data.marketer;            
        }).catch(() => {
            if (route.path != '/member/login') {
                router.push({ path:'/member/login', query: { path: route.path } });
            }
        });
    };
    if (doget) getMarketer();

    return { marketer, getMarketer };
}

export function useMarketerPasswordReset() {
    const password = ref("");
    const password2 = ref("");
    const finish = ref(false);
    const route = useRoute();

    const resetPassword = async () => {
      if (password.value != password2.value) {
        alert("確認用のパスワードが一致しません");
        return;
      } else if (!/^(?=.*?[a-zA-Z])(?=.*?\d).{8,100}$/.test(password.value)) {
        alert("8文字以上、英字と数字を両方使用して下さい");
        return;
      }
      await http.post('/api/marketer/reset_password/'+route.params.token, { password: password.value });
      finish.value = true;
    };

    return { password, password2, finish, resetPassword };
}

export function useLogin() {
    const router = useRouter();
    
    return () => router.push('/member/login');
}

export const genders = [
    { value: 1, label: "男性" },
    { value: 2, label: "女性" },
];

export const available_days = [
    { value: 1, label: "1日" },
    { value: 2, label: "2日" },
    { value: 3, label: "3日" },
    { value: 4, label: "4日" },
    { value: 5, label: "5日" },
    { value: 8, label: "週末のみ" },
];

export const working_types = [
    { value: 1, label: "フリーランス" },
    { value: 2, label: "副業" },
];

export const role_types = [
    { value: 1, label: "サイトオーナー" },
    { value: 2, label: "ディレクター" },
    { value: 3, label: "ライター" },
    { value: null, label: "その他" },
];

export const layers = [
    { value: "S", text: "S" },
    { value: "A", text: "A" },
    { value: "B", text: "B" },
    { value: "C", text: "C" },
    { value: null, text: "--" },
];

export const skills = [
    { value: "S", text: "S" },
    { value: "A", text: "A" },
    { value: "B", text: "B" },
    { value: "C", text: "C" },
    { value: "D", text: "D" },
    { value: "E", text: "E" },
    { value: null, text: "--" },
];

export const ratings = [
    { value: "S", text: "S" },
    { value: "A", text: "A" },
    { value: "B", text: "B" },
    { value: "C", text: "C" },
    { value: "D", text: "D" },
    { value: null, text: "--" },
];

export const account_types = [
    { text: "普通", value: 1 },
    { text: "当座", value: 2 },
    { text: "定期", value: 3 },
];

export function accountTypeName(val) {
    return account_types.filter(a => a.value == val)[0]?.text;
}

export default { marketer_age, gender, available_day, working_type, role_type, status, unit_value };